<template>
    <div class="card">
        <div class="card-body">
            <h2>Jobs Created per Month</h2>
            <p v-if="!loaded">
                Loading...
            </p>
            <div id="jobs-chart" />
        </div>
    </div>
</template>
<script>
import ApexCharts from 'apexcharts';
import ChartsService from '../../../services/ChartsService';

export default {
    data() {
        return {
            jobsData: null,
            chart: null,
            options: {
                chart: {
                    type: 'line'
                },
                stroke: {
                    curve: 'smooth'
                },
                fill: {
                    type: 'solid',
                    opacity: [0.35, 1]
                }
            },
            loaded: false
        };
    },

    mounted() {
        ChartsService.jobs().then(res => {
            this.jobsData = res.data;
            const lastYear = this.jobsData.slice(0, 12);
            const thisYear = this.jobsData.slice(12);

            this.options.series = [
                {
                    name: 'This Year',
                    data: thisYear.map(data => data.count),
                },
                {
                    name: 'Last Year',
                    data: lastYear.map(data => data.count),
                }
            ];
            this.options.xaxis = {
                categories: lastYear.map(data =>
                    window
                        .moment()
                        .month(parseInt(data.date.substring(5)) - 1)
                        .format('MMM')
                )
            };
            this.chart = new ApexCharts(
                document.getElementById('jobs-chart'),
                this.options
            );
            this.loaded = true;
            this.chart.render();
        });
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/widgets/JobsChartComponent.vue